// import something here
import '@fortawesome/fontawesome-free/css/fontawesome.css';
import '@fortawesome/fontawesome-free/css/solid.css';
import '@fortawesome/fontawesome-free/css/regular.css';
// do you want these too?
// import '@fortawesome/fontawesome-pro-webfonts/css/fa-light.css';
import '@fortawesome/fontawesome-free/css/brands.css';
// leave the export, even if you don't use it
export default () => {
  // something to do
};



// WEBPACK FOOTER //
// ./src/plugins/fontawesome-free.js